import { useEffect } from "react";
import styled from "styled-components";
import { FaHeart } from "react-icons/fa";
import { useFavorites } from "./FavoritesContext";

const HeartButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 22px;
  color: ${({ $isFavorite }) => ($isFavorite ? "red" : "#ccc")};
  transition: color 0.3s;
  &:hover { color: ${({ $isFavorite }) => ($isFavorite ? "#aa0000" : "#999")}; }
`;

const FavoriteButton = ({ productId, giftSetId, kind, initialIsFavorite }) => {
  const { isFavorite, toggleFavorite, seedFavoriteFromInitial } = useFavorites();

  const resolvedKind = giftSetId ? "gift_set" : (kind || "product");
  const id = resolvedKind === "gift_set" ? giftSetId : productId;

  // ერთი სწრაფი განflicker-ება: თუ ბექი გვიგზავნის initialIsFavorite-ს,
  // გადავუშვათ კონტექსტში, რომ გულიკი უკვე იყოს სწორ ფერში ჯერ კიდევ პირველ რენდერზე.
  useEffect(() => {
    if (typeof initialIsFavorite !== "undefined" && id) {
      seedFavoriteFromInitial(resolvedKind, id, !!initialIsFavorite);
    }
  }, [resolvedKind, id, initialIsFavorite, seedFavoriteFromInitial]);

  const fav = id ? isFavorite(resolvedKind, id) : false;

  const onClick = (e) => {
    e.stopPropagation();
    if (!id) return;
    toggleFavorite(resolvedKind, id); // ოპტიმისტურად აითიშება/აირთვება ყველგან
  };

  return (
    <HeartButton
      onClick={onClick}
      $isFavorite={fav}
      title={fav ? "Remove from favorites" : "Add to favorites"}
      aria-label={fav ? "Remove from favorites" : "Add to favorites"}
    >
      <FaHeart />
    </HeartButton>
  );
};

export default FavoriteButton;
